import { IPaginationDTO, IPaginationResponse } from '@/models/pagination.model';
import { IBlogSeo } from './blogPost.model';

export enum BrandsEndpoints {
  ROOT = '/brands',
}

export const staticBrandsEndpoints = {
  GET_BRANDS: BrandsEndpoints.ROOT,
};

export const getBrandsEndpoints = ({ id }: { id: string }) => ({
  UPDATE_BRAND: `${BrandsEndpoints.ROOT}/${id}`,
});

export type IBrand = {
  id: string;
  code: string;
  files?: Array<{ metaType: string; file: { url: string } }>;
  labels: { en_US?: string };
  sortOrder: number;
  showOnBrandPage: boolean;
  title: string;
  description: string;
  imageTitle: string;
  bannerTitle: string;
  seo: IBlogSeo;
  createdAt: string;
  updatedAt: string;
};

// ============== DTO ==============

export interface IGetBrandsDTO extends IPaginationDTO {
  channelId: number;
  search?: string;
}

export interface IUploadBrandDetailsDTO {
  channelId: number;
  id: string;
  showOnBrandPage?: boolean;
  logo?: File;
  banner?: File;
  title?: string;
  description?: string;
  imageTitle?: string;
  bannerTitle?: string;
  seo?: IBlogSeo;
}

// ============== Response ==============

export interface IGetBrandsResponse extends IPaginationResponse {
  brands: IBrand[];
}

export type IUpdateBrandResponse = IBrand;
